import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import '../../../styles/Footer.css';
import MenuContext, { MenuProvider } from '../../Context/menuProvider';
function Footer() {
  const { setImage, image } = useContext(MenuContext)

  return (
    <div className='Footer'>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="logo">
              <img src={image} alt="prime skin clinic logo" />

            </div>
            {/* <p className='quote'>Locking Excellence, Opening Peace of Mind!</p> */}
            <div className="social-media-icons">
              <a href="https://www.facebook.com/primelasercliniccalicut/" target="_blank" rel="noopener noreferrer">
                <i class="fa-brands fa-facebook"></i>

              </a>
              <a href="https://www.instagram.com/drroshnis_prime_skin_clinic/" target="_blank"
                rel="noopener noreferrer">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a href="https://youtube.com/@primeskintalks994?si=oURwOqW1hXqPHp_B" target="_blank"
                rel="noopener noreferrer">
                <i class="fa-brands fa-youtube"></i>
              </a>

            </div>

          </div>
          <div className="col">

            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>

            </li>
            <li>
              <Link to="/areas-of-treatment">Areas of Treatment</Link>
            </li>





          </div>
          <div className="col">


            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/blogs">Blogs</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </div>
          <div className="col right">
            <div className="icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <div className="content">
              <p>2nd Floor, VEEPEE Space,</p>
              <p>Wayanad Road Civil station P.O,</p>
              <p> Eranhippalam, Kozhikode, </p>
              <p>Kerala, 673020</p>
            </div>
          </div>
        </div>

      </div>
      <div className="copyright">
        <p>© Copyright - PrimeSkin & Laser Clinic</p>
      </div>
    </div>
  )
}

export default Footer